import styled from 'styled-components';

export const Wrapper = styled.div`
  p {
    color: #fff;
    font-size: 18px;
  }
`;
